import { useToast } from './useToast';

export const useCopyToClipboard = () => {
  const { showToast } = useToast();

  const copy = async (text: string, displayValue?: string) => {
    try {
      await navigator.clipboard.writeText(text);
      const toastValue = displayValue ?? text;
      showToast({
        message: `"${toastValue}" copied to clipboard`,
        type: 'success',
      });
    } catch {
      showToast({
        message: 'Failed to copy to clipboard',
        type: 'error',
      });
    }
  };

  return { copy };
};
